package com.exura.features.publicplans.domain.usecase

import com.exura.features.publicplans.domain.PublicPlansConstants
import com.exura.features.publicplans.domain.api.EnablePublicPlanSharingRequest
import com.exura.features.publicplans.domain.api.EnablePublicPlanSharingResponse
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import dev.gitlive.firebase.functions.FirebaseFunctions

class EnablePublicPlanSharingUseCase(
    private val functions: FirebaseFunctions,
    private val repository: ProviderPublicPlanRepository,
) {
    suspend operator fun invoke(publicPlanId: String): Result<Boolean> = runCatching {
        val publicEntry = repository.read(publicPlanId).getOrThrow()
        val callable = functions.httpsCallable(PublicPlansConstants.Functions.GLOBAL_ENABLE_PUBLIC_PLAN_SHARING)

        val response = callable.invoke(
            EnablePublicPlanSharingRequest(globalEntryId = publicEntry.globalEntryId)
        )
        val result = response.data<EnablePublicPlanSharingResponse>()

        if (result.success) {
            repository.enableSharing(publicPlanId).getOrThrow()
            true
        } else {
            throw Exception(result.message ?: "Failed to enable plan public")
        }

    }
}
